import { render, staticRenderFns } from "./PriceDetailPage.vue?vue&type=template&id=a147a03c&scoped=true&"
import script from "./PriceDetailPage.vue?vue&type=script&lang=js&"
export * from "./PriceDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147a03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a147a03c')) {
      api.createRecord('a147a03c', component.options)
    } else {
      api.reload('a147a03c', component.options)
    }
    module.hot.accept("./PriceDetailPage.vue?vue&type=template&id=a147a03c&scoped=true&", function () {
      api.rerender('a147a03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/PriceDetailPage.vue"
export default component.exports